import React from 'react';
import PropTypes from 'prop-types';
import { Typography, SpacerVertical } from '@klarna/bubble-ui';
import { ProductPricing } from 'moet-core';
import { Column, Row } from 'mage-components';

const ProductPrices = ({ products = [] }) => (
  <Row>
    {products &&
      products.map(product => {
        return (
          <Column columns={{ tablet: 4 }} key={product.id}>
            <Typography textToken="text-style/text/super-paragraphs/body/regular">
              {product.name}
            </Typography>
            <SpacerVertical spaceToken="space/100" />
            <Typography textToken="text-style/headings/titles/bold/grande">
              {product.price ? <ProductPricing price={product.price} /> : <div>-*</div>}
            </Typography>
          </Column>
        );
      })}
  </Row>
);

ProductPrices.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.object,
    }),
  ).isRequired,
};

export default ProductPrices;
